export const Type = {
  LIGHT: 'light',
  DARK: 'dark',
} as const;

export type Type = Union<typeof Type>;
